const pix = {
  PIX_INVALID_KEY_TYPE: {
    message: 'Invalid Pix key type',
    field: 'key_type',
    code: 'PIX_1'
  },
  PIX_KEY_INVALID_EMAIL: {
    message: 'The email must be valid',
    field: 'key',
    code: 'PIX_2'
  },
  PIX_KEY_INVALID_DOCUMENT: {
    message: 'Provided document is not a CPF nor CNPJ',
    field: 'key',
    code: 'PIX_3'
  },
  PIX_KEY_INVALID_PHONE: {
    message: 'The phone number must be valid',
    field: 'key',
    code: 'PIX_4'
  },
  PIX_KEY_DUPLICATED: {
    message: 'Provided Pix key already exists',
    field: 'key',
    code: 'PIX_5'
  },
  PIX_KEY_INVALID_VERIFICATION_CODE: {
    message: 'Invalid verification code for Pix key',
    field: 'code',
    code: 'PIX_6'
  },
  PIX_MAX_KEY_LIMIT_EXCEEDED: {
    message: 'Pix key was not registered as you can only register 20 keys in your account',
    field: null,
    code: 'PIX_7'
  },
  INVALID_DATE_FORMAT: {
    message: 'Invalid date format',
    field: null,
    code: 'PIX_8'
  },
  MIN_VALUE: {
    message: 'The value must not be lower than R$0,00',
    field: null,
    code: 'PIX_9'
  },
  PAYER_INVALID_PERSON_TYPE: {
    message: "The payer's type must be valid",
    field: 'payer.document',
    code: 'PIX_10'
  },
  PAYER_INVALID_DOCUMENT: {
    message: "The payer's document is not a CPF or CNPJ",
    field: 'payer.document',
    code: 'PIX_11'
  },
  PAYER_INVALID_NAME: {
    message: "The payer's name must be valid",
    field: 'payer.name',
    code: 'PIX_12'
  },
  PAYER_INVALID_EMAIL: {
    message: "The payer's email must be valid",
    field: 'payer.email',
    code: 'PIX_13'
  },
  PAYER_INVALID_PHONE: {
    message: "The payer's phone number must be valid",
    field: 'payer.phone',
    code: 'PIX_14'
  },
  PIX_KEY_NOT_FOUND: {
    message: 'Pix key not found',
    field: 'pix_key',
    code: 'PIX_15'
  },
  UNABLE_TO_SEND_PIX_TO_SALARY_ACCOUNT: {
    message: 'Unable to send Pix to salary account',
    field: null,
    code: 'PIX_16'
  },
  QRCODE_INVALID_DATE: {
    message: 'Invalid date',
    field: null,
    code: 'PIX_17'
  },
  PIX_KEY_IN_CLAIM_PROCESS: {
    message:
      'This key is already registered and is in the process of being claimed. You will not be able to register it until the process is finished.',
    field: null,
    code: 'PIX_18'
  },
  CANT_DELETE_KEYS_IN_CLAIM_PROCESS: {
    message: 'You cannot delete keys that are in the claim process. Wait for the process to complete',
    field: null,
    code: 'PIX_19'
  },
  INVALID_STATUS_TO_START_A_CLAIM_PROCESS: {
    message: 'Key status does not allow to start a claim process',
    field: null,
    code: 'PIX_20'
  },
  INVALID_STATUS_TO_CANCEL_THE_CLAIM_PROCESS: {
    message: 'Key status does not allow to cancel the claim process',
    field: null,
    code: 'PIX_21'
  },
  INVALID_STATUS_TO_CONFIRM_THE_CLAIM_PROCESS: {
    message: 'Key status does not allow to confirm the claim process',
    field: null,
    code: 'PIX_22'
  },
  CLAIM_ALREADY_EXISTS_FOR_KEY: {
    message: 'There is already an ongoing claim process for this key',
    field: null,
    code: 'PIX_23'
  },
  PIX_RETURNED: {
    // deprecated
    message: 'Pix returned',
    field: null,
    code: 'PIX_24'
  },
  PIX_RETRY_FAILED: {
    message: 'After a few attempts, we were unable to send the transfer to the destination bank',
    field: null,
    code: 'PIX_25'
  },
  QRCODE_DUPLICATED: {
    message: 'QRCode data is duplicated',
    field: null,
    code: 'PIX_26'
  },
  QRCODE_CANT_UPDATE: {
    message: "QRCode finished, can't be updated",
    field: null,
    code: 'PIX_27'
  },
  PIX_KEY_INVALID_EVP: {
    message: 'Format of EVP key is invalid',
    field: 'pix_key',
    code: 'PIX_28'
  },
  PIX_KEY_DOCUMENT_INCONSISTENT_STATUS: {
    message: 'Inconsistency in the registration status of the document',
    field: 'pix_key',
    code: 'PIX_29'
  },
  PIX_REFUND_EXCEEDS_VALUE: {
    message: 'Refunds values exceeds the pix received value',
    field: null,
    code: 'PIX_30'
  },
  PIX_REFUND_DEADLINE_EXCEEDED: {
    message: 'Refund 90 days deadline exceeded',
    field: null,
    code: 'PIX_31'
  },
  PIX_REFUND_DUPLICATED: {
    message: 'Refund identifier duplicated',
    field: null,
    code: 'PIX_32'
  },
  PIX_KEY_INVALID_DOCUMENT_FORMAT: {
    message: 'The document format is invalid',
    field: 'pix_key',
    code: 'PIX_33'
  },
  PIX_KEY_DOCUMENT_DOEST_NOT_EXIST: {
    message: 'Document does not exist',
    field: 'pix_key',
    code: 'PIX_34'
  },
  INFORMED_DOCUMENT_IS_DIVERGENT_FROM_PIX_KEY_OWNER: {
    message: 'Informed document is divergent from the document of the Pix key owner',
    field: 'cpf_cnpj',
    code: 'PIX_35'
  },
  PIX_KEY_INVALID_AREA_CODE: {
    message: 'Invalid phone pix key area code',
    field: 'pix_key',
    code: 'PIX_36'
  },
  DATA_VALIDATION_INVALID_DOCUMENT_FORMAT: {
    message: 'The document informed for validation is invalid',
    field: 'pix_key_validation.cpf_cnpj',
    code: 'PIX_37'
  },
  QRCODE_SPLIT_INVALID_VALUE_CHANGE_MODE: {
    message:
      'It is not allowed to create fixed value splits for QRCodes when the parameter "value_change_mode" is "MODIFICAVEL"',
    field: 'split_payment',
    code: 'PIX_38'
  },
  QRCODE_SPLIT_EXCEED_QR_CODE_VALUE: {
    message: 'Split(s) value exceeds QRCode value',
    field: 'split_payment',
    code: 'PIX_39'
  },
  QRCODE_VALUE_INVALID: {
    message: 'Invalid QRCode value',
    field: 'original_value',
    code: 'PIX_40'
  },
  QRCODE_CANT_USE_BOTH_WITHDRAW_AND_CHANGE: {
    message: "Can't use both withdraw and change fields in the same QRCode",
    code: 'PIX_41'
  },
  PIX_DESCRIPTION_INVALID_CHARACTER: {
    message: 'Description contains invalid characters',
    field: 'pix_description',
    code: 'PIX_42'
  },
  INVALID_STATUS_TO_REMOVE_KEY: {
    message: 'Key status does not allow removal',
    field: null,
    code: 'PIX_43'
  },
  EXPIRED_E2E_ID: {
    message: 'Expired end2end id, it cannot be used anymore for transaction processing',
    field: null,
    code: 'PIX_44'
  },
  DUPLICATED_E2E_ID: {
    message: 'Duplicated end2end id, it was already used in another transaction ({{duplicatedEnd2endIds}})',
    field: 'pix_end2end_id',
    variable: 'duplicatedEnd2endIds',
    code: 'PIX_45'
  },
  PIX_REFUND_BLOCKED: {
    message: 'Pix blocked for refunds because it is associated to a MED in progress',
    field: 'pix_end2end_id',
    code: 'PIX_46'
  },
  PIX_KEY_INVALID_FORMAT: {
    message: 'Invalid pix key format',
    field: 'key',
    code: 'PIX_47'
  },
  PIX_MAX_KEY_LIMIT_EXCEEDED_TO_NATURAL_PERSON: {
    message: 'Pix key was not registered as you can only register 5 keys in your account',
    field: null,
    code: 'PIX_48'
  },
  PIX_KEY_TYPE_CREATION_NOT_ALLOWED: {
    message: 'Pix key of type {{key_type}} is not allowed for your account type',
    field: 'key',
    code: 'PIX_49',
    variable: 'key_type'
  },
  INFORMED_PIX_KEY_DOCUMENT_IS_DIVERGENT_FROM_ACCOUNT_OWNER: {
    message: 'Informed Pix key {{key_type}} is divergent from the tax ID of the account owner',
    field: 'key',
    code: 'PIX_50',
    variable: 'key_type'
  },
  PIX_KEY_SEARCH_RATE_LIMIT_EXCEEDED: {
    message: 'Limit of Pix key queries in DICT exceeded',
    field: 'null',
    code: 'PIX_51'
  }
};

module.exports = pix;
